<template>
    <main class="pt-5">
        <v-container>

                <!--Grid row-->
                <v-row>
                    <v-col class="my-4">
                        <v-card elevation="4" class="white">
                            <v-alert text prominent type="info" class="text-left text-h5">
                                  <b>Page not found.</b><br/>We couldn’t find the page you were looking for. Please contact us at <a heref="mailto:groupsubs@scmp.com">groupsubs@scmp.com</a>
                            </v-alert>
                        </v-card>
                    </v-col>
                </v-row>


        </v-container>
    </main>
</template>

<script>

export default {
    name: '404',
    components: {
    },
    data() {

        return {


        };
    },
    computed: {

    },
    created(){

    },
    mounted(){

    },
    methods: {

    }
}

</script>
